import { render, staticRenderFns } from "./ChatGroupCard.vue?vue&type=template&id=4142f244&"
import script from "./ChatGroupCard.vue?vue&type=script&lang=js&"
export * from "./ChatGroupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports